/**
 * Resolves a URL path + query for navigating to a draft label viewer.
 *
 * URL contract (from project A):
 *   /drug/{drug_id}?source=draft&version={label_version_id}[&comment={comment_id}]
 *
 * @param result - The draft search result containing drug_id and label_version_id.
 * @param hit    - A specific hit within the result; when kind === 'comment' and
 *                 comment_id is present, a `comment` param is appended.
 * @returns An object with `path` (string) and `query` (Record<string, string | number>).
 *          The caller is responsible for serialising `query` into a URL search string.
 */
export function resolveDraftTarget(
  result: { drug_id: number; label_version_id: number },
  // ``comment_id`` may be ``null`` on the wire (backend serialises content
  // hits with ``comment_id: null``); the ``!= null`` guard below handles it.
  hit: { kind: 'content' | 'comment'; comment_id?: number | null },
): { path: string; query: Record<string, string | number> } {
  return {
    path: `/drug/${result.drug_id}`,
    query: {
      source: 'draft',
      version: result.label_version_id,
      ...(hit.kind === 'comment' && hit.comment_id != null
        ? { comment: hit.comment_id }
        : {}),
    },
  };
}
